const escapeHtml = (text) => text.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);

// Escapes plain policy text, then turns emails and URLs into links.
export function linkify(text) {
	return escapeHtml(text).replace(/(https?:\/\/[^\s,)]+[^\s,).])|([\w.+-]+@[\w-]+\.[\w.]+\w)/g, (match, url, email) => {
		if (email) return `<a href="mailto:${email.toLowerCase()}">${email.toLowerCase()}</a>`;
		if (/^https?:\/\/(www\.)?paydeck\.in(\/|$)/.test(url)) return `<a href="${url.replace(/^https?:\/\/(www\.)?paydeck\.in/, "") || "/"}">${url}</a>`;
		return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
	});
}
